import axios from 'axios';


export function getAnalyticsLinksList() {
    return axios({
        method: 'GET',
        url: '/api/v2/adminPanel/analytics',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function createAnalyticsLinks(records) {
    return axios({
        method: 'POST',
        url: '/api/v2/adminPanel/analytics',
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json',
        },
        data: {
            records,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function updateAnalyticsLinksList(record) {
    return axios({
        method: 'PUT',
        url: `/api/v2/adminPanel/analytics/${record._id}`,
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json',
        },
        data: {
            record,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function deleteAnalyticLink(recordId) {
    return axios({
        method: 'DELETE',
        url: `/api/v2/adminPanel/analytics/${recordId}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function findAnalyticsTags(search) {
    return axios({
        method: 'GET',
        url: `/api/v2/adminPanel/analytics/findTags/${search}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function sendToDev(id) {
    return axios({
        method: 'PUT',
        url: `/api/v1/mails/share/dev/${id}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/analytics/linksList.js